/**
 * Dashboard va hisobot qatorlari uchun ixcham o'ng tugma menyulari (recruiter, jamoa, filial, tasdiq turi).
 * Driver va vazifa qatorlari umumiy menyulardan foydalanadi (features/drivers, features/tasks).
 */
import { Briefcase, ChartColumn, ExternalLink, Eye, Filter, LayoutDashboard, Users, UsersRound, Wallet } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { Permission } from "@/features/auth/types";
import type { Translate } from "@/features/drivers/menu";
import { profileItem, type ProfileAction } from "@/features/people/profileAction";

export interface PathActions {
  navigate: (path: string) => void;
  openNewTab: (path: string) => void;
  profile?: ProfileAction;
  /** Bo'limga olib boradigan band faqat ruxsat bo'lsa (hisobot, budjet, xodimlar) */
  can: (perm: Permission) => boolean;
}

/** focus -- hisobot ichida: boshqa sahifaga o'tmasdan shu recruiter bo'yicha filtrlash */
export function recruiterRowMenu(row: { user_id: number; display_name: string }, a: PathActions & { focus?: () => void }, t: Translate): MenuEntry[] {
  return compactMenu([
    profileItem(a.profile, row.user_id, t),
    { key: "drivers", label: t("recruiter.showDrivers", { name: row.display_name }), icon: Users, onSelect: () => a.navigate(`/drivers?owner=${row.user_id}`) },
    a.focus
      ? { key: "focus", label: t("recruiter.focus", { name: row.display_name }), icon: Filter, onSelect: a.focus }
      : a.can("reports") && { key: "report", label: t("recruiter.openReport"), icon: ChartColumn, onSelect: () => a.navigate(`/reports?recruiter=${row.user_id}`) },
  ]);
}

export function sourceRowMenu(source: string, label: string, a: PathActions, t: Translate): MenuEntry[] {
  return compactMenu([{ key: "drivers", label: t("report.sourceDrivers", { source: label }), icon: Users, onSelect: () => a.navigate(`/drivers?source=${source}`) }]);
}

export function carrierRowMenu(row: { carrier_id: number; carrier: string }, a: PathActions, t: Translate): MenuEntry[] {
  const path = `/carriers/${row.carrier_id}`;
  return compactMenu([
    { key: "open", label: t("open"), icon: Eye, onSelect: () => a.navigate(path) },
    { key: "open-tab", label: t("openNewTab"), icon: ExternalLink, onSelect: () => a.openNewTab(path) },
    SEPARATOR,
    { key: "jobs", label: t("report.carrierJobs"), icon: Briefcase, onSelect: () => a.navigate(`/jobs?carrier=${row.carrier_id}`) },
  ]);
}


export interface BranchRowActions extends PathActions {
  openDashboard: () => void;
  openBudget: () => void;
}

export function branchRowMenu(row: { branch_id: number }, a: BranchRowActions, t: Translate): MenuEntry[] {
  return compactMenu([
    { key: "dashboard", label: t("branch.openDashboard"), icon: LayoutDashboard, onSelect: a.openDashboard },
    a.can("budget") && { key: "budget", label: t("branch.openBudget"), icon: Wallet, onSelect: a.openBudget },
    a.can("reports") && { key: "report", label: t("branch.openReport"), icon: ChartColumn, onSelect: () => a.navigate(`/reports?branch=${row.branch_id}`) },
    SEPARATOR,
    a.can("users") && { key: "users", label: t("branch.people"), icon: UsersRound, onSelect: () => a.navigate(`/admin/users?branch=${row.branch_id}`) },
  ]);
}

export function linkMenu(path: string, a: PathActions, t: Translate): MenuEntry[] {
  return compactMenu([
    { key: "open", label: t("open"), icon: Eye, onSelect: () => a.navigate(path) },
    { key: "open-tab", label: t("openNewTab"), icon: ExternalLink, onSelect: () => a.openNewTab(path) },
  ]);
}
